// start:ng42.barrel
import './components';
import './directives';
import './event-register-transport.service';
import './event-registers.service';
import './events.constants';
import './events.service';
// end:ng42.barrel

